export async function getCourseDashboard(token) {
  return request("/api/course/dashboard", {
    method: "GET",
    token: token
  });
}

export async function getCourseDetail(id, token) {
  return request("/api/course/" + id, {
    method: "GET",
    token: token
  });
}

export async function joinCourse(id, token) {
  return request("/api/course/" + id + "/join", {
    method: "POST",
    token: token
  });
}

async function request(url, options) {
  var settings = options || {};
  var headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  if (settings.token) {
    headers.Authorization = "Bearer " + settings.token;
  }

  var response = await fetch(url, {
    method: settings.method || "GET",
    headers: headers,
    body: settings.body ? JSON.stringify(settings.body) : undefined
  });

  var data = null;
  var contentType = response.headers.get("content-type") || "";

  if (contentType.indexOf("application/json") > -1) {
    data = await response.json();
  } else if (response.status !== 204) {
    data = await response.text();
  }

  if (!response.ok) {
    var error = new Error(resolveErrorMessage(response.status, data));
    error.status = response.status;
    error.data = data;
    error.validationErrors = data && data.errors ? data.errors : null;
    throw error;
  }

  return data;
}

function resolveErrorMessage(status, data) {
  if (status === 422 && data && data.errors) {
    var firstKey = Object.keys(data.errors)[0];
    if (firstKey && data.errors[firstKey] && data.errors[firstKey][0]) {
      return data.errors[firstKey][0];
    }
  }

  if (data && data.message) {
    return data.message;
  }

  if (status === 401) {
    return "登录状态已失效，请重新登录。";
  }

  if (status === 404) {
    return "课程不存在。";
  }

  if (status === 500) {
    return "服务器异常，请稍后重试。";
  }

  return "请求失败，请稍后重试。";
}
